// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "categories__list-2UYe1";
var _3 = "filtersRange__item-18CMq";
var _4 = "filtersType__title-1yUCR";
export { _1 as "__esModule", _2 as "categories__list", _3 as "filtersRange__item", _4 as "filtersType__title" }
export default { "__esModule": _1, "categories__list": _2, "filtersRange__item": _3, "filtersType__title": _4 }
